export default "__VITE_ASSET__CU$C7mCN__"